<script lang="ts">
  import { isLoggedIn, loginWithPassword } from "$lib/store/auth-context";
  import { isLoading } from "$lib/store/loading-context";
  import { closeAllModals } from "@thehood/svlib";

  export let step: number;
  export let email: string;

  let password = "";

  function backBtn(ev: Event) {
    ev.stopImmediatePropagation();
    step = 1;
  }

  let maskPassword = true;
  function togglePasswordField(ev: Event) {
    ev.stopImmediatePropagation();
    maskPassword = !maskPassword;
  }

  let errorMsg = "";

  async function submitLogin(ev: Event) {
    ev.stopImmediatePropagation();
    ev.preventDefault();
    if (!`${password}`.trim()) {
      return;
    }
    isLoading.set(true);
    maskPassword = true;
    try {
      const resp = await loginWithPassword(email, password);
      if (!resp.ok) {
        if (resp.status >= 400 && resp.status < 500) {
          const data = await resp.json();
          if (data.error) {
            throw new Error(data.error);
          }
        }

        // 500 Errors
        throw new Error(resp.statusText);
      }

      // Successfully loggedin
      const data = await resp.json();
      const { status } = data;
      if (!status) {
        return;
      }
      isLoggedIn.update(() => true);
      closeAllModals();
      window.location.reload();
    } catch (err) {
      errorMsg = (err as Error).message;
    } finally {
      isLoading.set(false);
    }
  }
</script>

<div class="container">
  <h1 class="pf-700"><slot />Password Login {$isLoading}</h1>
  <hr class="row" />
  <form on:submit={submitLogin}>
    <input id="email-input" type="email" disabled value={email} />

    <div class="row">
      <div class="password-container">
        {#if maskPassword}
          <input
            type="password"
            id="password"
            class="password-field"
            placeholder="Enter your password"
            bind:value={password}
          />
        {:else}
          <input
            type="text"
            id="password"
            class="password-field"
            placeholder="Enter your password"
            bind:value={password}
          />
        {/if}
        <button class="toggle-icon" type="button" class:show={!maskPassword} on:click={togglePasswordField}
          >&nbsp;</button
        >
      </div>
      {#if errorMsg}
        <span class="danger pf-500">Error: {errorMsg}</span>
      {/if}
    </div>

    <div class="actions">
      <button class="btn pf-700" type="button" on:click={backBtn} disabled={$isLoading}>Back</button>
      <button class="btn pf-700" type="submit" disabled={$isLoading}>Login</button>
    </div>
  </form>

  <hr />
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .container {
    position: relative;
  }

  h1 {
    align-self: flex-start;
    font-size: 1.25em;
    margin: 0;
    line-height: 1.5em;
  }

  hr {
    margin-top: calc(1em / 0.875 * 1.25);
    border-top: 1px solid var(--hr-color);
  }

  .row {
    margin-bottom: calc(1em / 0.875 * 1.25);
  }

  .password-container {
    position: relative;
    display: flex;
    align-items: center;
  }

  .toggle-icon {
    position: absolute;
    top: calc(1.25em / 2);
    right: 10px;
    padding: 0;
    border: 0;
    width: 32px;
    height: 32px;
    background: url(./assets/hidden.svg) center;
    background-size: contain;
    &.show {
      background-image: url(./assets/show.svg);
    }
  }

  .actions {
    display: flex;
    gap: 10px;

    button {
      width: 100%;
      min-height: 3.08956em;
      border-radius: 0.3125em;
      line-height: 1.875em;
      @include desktop {
        min-height: 3.125em;
      }
    }
  }
</style>
